<template>

    <router-link v-if="to" class="nav-item" :class="{ active: isActive }" :to="to">
        <i v-if="icon" class="mr-5" :class="icon" />
        <span>{{ label }}</span>
    </router-link>

    <div v-else class="nav-item" :class="{ active: isActive }">
        <i v-if="icon" class="mr-5" :class="icon" />
        <span>{{ label }}</span>
    </div>

</template>

<style scoped lang="scss">

    .nav-item {
        @include font-medium(12px);
        border-radius: 15px;
        color: $color-text;
        cursor: pointer;
        line-height: 30px;
        padding: 0 10px;
        text-decoration: none;
        transition: background-color .3s,  color .3s;
        user-select: none;
        &:hover {
            background: $color-highlight;
        }
        &.active {
            background: $color-highlight;
            color: $color-primary;
        }
    }

</style>

<script>

export default {

    props: {
        label: {
            type: String,
            default: 'Title',
        },
        to: {
            type: Object,
            default: null,
        },
        active: {
            type: Boolean,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
    },

    computed: {

        isActive() {
            if (this.active !== null) {
                return this.active;
            } else if (this.to) {
                return this.$route.name.startsWith(this.to.name);
            }
            return false;
        },

    },

}

</script>